module.exports = __webpack_public_path__ + "img/1.0a8218f8.png";